<!-- Step-bar source:  https://github.com/ni-30/vuejs-step-progressbar-component -->
<template>
  <div class="step-progress-bar container mt-4">
    <div class="container row">
      <div class="col">
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            aria-valuenow="0"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div
              v-for="(title, i) in stepTitles"
              :key="doMath(i)"
              :ref="'step-circle-' + doMath(i)"
              :class="[
                'step-circle',
                'not-started-step-circle',
                'text-left',
                'font-weight-bold',
              ]"
              :style="{
                left: ((doMath(i) - 1) * 100) / (totalSteps - 1) + '%',
              }"
            >
              <!-- {{ doMath(i) }} -->
              <p></p>
              <!-- shows the names of the steps to complete
               only when the screen resolution is > 900 px
               to prevent letters from looking too close together-->
              <p
                v-show="windowWidth > 900"
                style="margin-left: -42px; margin-right: 5px;"
              >
                {{ title }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h4
      ref="stepTitleRef"
      class="step-title-header mt-4 text-center font-weight-bold mx-auto"
    ></h4>
  </div>
</template>

<script>
export default {
  name: 'StepProgressBar',
  // eslint-disable-next-line vue/require-prop-types
  props: ['totalSteps', 'initCurrentStep', 'stepTitles'],
  data() {
    return {
      currentStep: this.initCurrentStep,
      windowWidth: window.innerWidth,
    };
  },
  watch: {
    currentStep: function() {
      this.updateProgressBar();
    },
  },
  mounted() {
    this.$nextTick(function() {
      this.updateProgressBar();
    });
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  methods: {
    doMath: function(index) {
      return index + 1;
    },
    changeCurrentStep: function(newStep) {
      if (newStep < 0) {
        this.currentStep = 0;
      } else if (newStep > this.totalSteps + 1) {
        this.currentStep = this.totalSteps + 1;
      } else {
        this.currentStep = newStep;
      }
    },
    updateProgressBar: function() {
      var totalCompletedSteps =
        this.currentStep > this.totalSteps
          ? this.totalSteps
          : this.currentStep <= 0
          ? 0
          : this.currentStep - 1;

      for (var i = 1; i <= this.totalSteps; i++) {
        var stepCircleElement = this.$refs['step-circle-' + i][0];
        if (i == this.currentStep) {
          stepCircleElement.classList.add('current-step-circle');
          stepCircleElement.classList.remove('completed-step-circle');
          stepCircleElement.classList.remove('not-started-step-circle');
        } else if (i <= totalCompletedSteps) {
          stepCircleElement.classList.add('completed-step-circle');
          stepCircleElement.classList.remove('current-step-circle');
          stepCircleElement.classList.remove('not-started-step-circle');
        } else {
          stepCircleElement.classList.add('not-started-step-circle');
          stepCircleElement.classList.remove('completed-step-circle');
          stepCircleElement.classList.remove('current-step-circle');
        }
      }
      var propgressBarInPercent =
        totalCompletedSteps == this.totalSteps
          ? 100
          : (totalCompletedSteps * 100) / (this.totalSteps - 1);
      window.$('.progress-bar').css('width', propgressBarInPercent + '%');
      //var stepTitle = this.stepTitles[this.currentStep - 1];
      //this.$refs.stepTitleRef.innerHTML =
      //stepTitle == undefined ? '' : stepTitle;
    },
  },
};
</script>

<style lang="scss">
.step-progress-bar .progress {
  height: 2px;
  position: relative;
  overflow: visible;
  background-color: #aaa;
  margin-top: 20px;
  margin-bottom: 40px;
}
.step-progress-bar .progress-bar {
  background-color: #673ab7;
}
.step-progress-bar .step-circle {
  border-style: solid;
  border-width: 4px;
  background: #aaa;
  position: absolute;
  display: table-cell;
  height: 15px;
  width: 15px;
  text-align: left;
  vertical-align: middle;
  border-radius: 50%;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 9px;
  margin-top: 0px;
  padding-top: 2px;
  margin-left: -5px;
}
.step-progress-bar .current-step-circle {
  color: #673ab7;
  background-color: #fff;
  border-color: #673ab7;
}
.step-progress-bar .completed-step-circle {
  color: #aaa;
  background-color: #673ab7;
  border-color: #673ab7;
}
.step-progress-bar .not-started-step-circle {
  color: #aaa;
  background-color: #fff;
  border-color: #aaa;
}
.step-title-header {
  font-family: Arial, Helvetica, sans-serif;
  color: #673ab7;
}
</style>
